import React from "react";
import { Reveal } from "../shared/Reveal";

const TRUSTED = ["mcdonalds", "accor", "nhs", "shangrila", "spar", "seven_eleven", "kfc"];

export default function Trusted() {
  return (
    <section>
      <div className="wrap">
        <Reveal className="eyebrow" tag="div" style={{ textAlign: "center" }}>TRUSTED BY INDUSTRY</Reveal>
        <Reveal className="lead" tag="p">We work with some of the UK's largest commercial organisations across manufacturing, food production, logistics, airports, healthcare, retail, hospitality, local authorities and multi-site estates.</Reveal>
        <Reveal className="clstrip" tag="div">
          {TRUSTED.map((b, i) => (
            <img src={`/brand/${b}.png`} alt={b} key={b} data-testid={`trusted-${i}`} />
          ))}
        </Reveal>
      </div>
    </section>
  );
}
